import { render, staticRenderFns } from "./airportdetails.vue?vue&type=template&id=6aab3736&scoped=true&"
import script from "./airportdetails.vue?vue&type=script&lang=js&"
export * from "./airportdetails.vue?vue&type=script&lang=js&"
import style0 from "./airportdetails.vue?vue&type=style&index=0&id=6aab3736&scoped=true&lang=css&"
import style1 from "./airportdetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aab3736",
  null
  
)

export default component.exports